export enum StudyPlanType {
  MODERATE = 'MODERATE',
  FREQUENT = 'FREQUENT',
  ACCELERATED = 'ACCELERATED',
}
